/**
 * Toast Provider Component
 *
 * Wraps the application with react-hot-toast's Toaster component
 * Provides consistent toast notifications throughout the app
 */

import { Toaster } from 'react-hot-toast';

export default function ToastProvider() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerStyle={{
        zIndex: 99999, // Ensure toasts are above everything (modals are z-50)
      }}
      toastOptions={{
        // Default options
        duration: 4000,
        style: {
          background: 'var(--color-bg-elevated)',
          color: 'var(--color-text-primary)',
          fontSize: '14px',
          borderRadius: '8px',
          padding: '12px 16px',
          border: '1px solid var(--color-border-default)',
          boxShadow: '0 4px 12px var(--color-shadow)',
        },
        // Success toast styles (always green with white text)
        success: {
          duration: 3000,
          style: {
            background: '#10B981',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#10B981',
          },
        },
        // Error toast styles (always red with white text)
        error: {
          duration: 5000,
          style: {
            background: '#EF4444',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#EF4444',
          },
        },
        // Loading toast styles (always blue with white text)
        loading: {
          style: {
            background: '#3B82F6',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#3B82F6',
          },
        },
      }}
    />
  );
}
